import React, { useContext, useEffect, useState } from 'react'
import { GirlsEvents } from './components/GirlsEvents'
import {
  AcademyContext,
  AcademyFilterObject,
} from '../../../Context/AcademyContext/AcademyContext'
import { AcademyEvent } from '../../../Api'

const AcademyGirls: React.FC = () => {
  const { academyEvents, returnFilteredEvents } = useContext(AcademyContext)!
  const [girlsEvs, setGirlsEvs] = useState<AcademyEvent[]>([])

  let filterObj: AcademyFilterObject = {
    participant: 'girls',
  }

  useEffect(() => {
    if (academyEvents.length > 0) {
      let girls = returnFilteredEvents(filterObj)
      setGirlsEvs(girls)
    }
  }, [academyEvents])

  return <GirlsEvents events={girlsEvs} />
}

export default AcademyGirls